import templateUrl from '../../views/workflows/details/send-template-modal.tpl.html';
import SendTemplateModalController from '../../controllers/workflows/details/send-template-modal-controller';

class SendTemplateWorkflow {
    constructor($injector) {
        this.translate = $injector.get('$translate');
        this.uibModal = $injector.get('$uibModal');
        this.alert = $injector.get('Alert');

        this.key = 'email-contact';
        this.title = this.translate.instant('templates.workflows.details.send-template.title');
        this.icon = 'envelope';
        this.order = 20;
        this.level = 'highlight';
    }

    action(template, vm) {
        this.uibModal.open({
            templateUrl,
            controller: SendTemplateModalController,
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                template() {
                    return template;
                }
            }
        }).result.then(null, err => this.alert.handle(err));
    }

}

angular
    .module('festzelt-os.modules.templates')
    .factory('sendTemplate', [
        '$injector',
        ($injector) => new SendTemplateWorkflow($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/templates/workflows/details/send-template.js